import axios from 'axios'
import qs from 'qs'

export async function fetchBaselineCalculations (borrower) {
  try {
    const response = await axios.post('/wp-admin/admin-ajax.php', qs.stringify({
      action: 'fetch_baseline_calculations',
      ...borrower
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    return response.data
  } catch (error) {
    console.error('Error fetching data', error)
  }
}

export async function fetchBaselinePrincipleGrowth (marginUsed, totalAvailableProceeds) {
  try {
    const response = await axios.post('/wp-admin/admin-ajax.php', qs.stringify({
      action: 'fetch_baseline_principle_growth',
      marginUsed,
      totalAvailableProceeds
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    return response.data
  } catch (error) {
    console.error('Error fetching data', error)
  }
}
